import React, { Component } from "react";

class DescriptionProps {
    description?: string;
}

class DescriptionState {}

class Description extends Component<DescriptionProps, DescriptionState> {

    render() {
        if (!this.props.description) {
            return <></>;
        }

        return (
            <div className="columns">
                <div className="column">
                    <h3 className="product-group is-size-5 has-text-weight-bold">Description</h3>
                    <div className="product-description">
                        {this.props.description}
                    </div>
                </div>
            </div>
        );
    }
}

export default Description;
